module.exports = __webpack_public_path__ + "img/Group20.69c8f960.png";